import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { RelaunchComponent } from './relaunch/relaunch.component';
import { BypassComponent } from './bypass/bypass.component';
import { TaskDetailsObject } from 'src/app/models/tasks/tasks-details/task-details.model';
import { ActivatedRoute, Router } from '@angular/router';
import { CharacteristicsObject } from 'src/app/models/characteristics/characteristics.model';
import { TaskAssignObject } from 'src/app/models/tasks/task/task-assign-object.model';
import { TaskOperationObject } from 'src/app/models/tasks/task/task-operation.model';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { TaskService } from 'src/app/services/api/tasks/specific-task/task.service';
import { MessageObject } from 'src/app/models/message/message-object.model';
import { KeycloakService } from 'keycloak-angular';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-tasks-details-characteristics',
  templateUrl: './tasks-details-characteristics.component.html',
  styleUrls: ['./tasks-details-characteristics.component.css']
})
export class TasksDetailsCharacteristicsComponent implements OnInit, OnChanges {

  editable: boolean;
  taskId: string;
  mustHideCharacteristics: boolean;
  diffCharacteristics: CharacteristicsObject;

  dialogBypassRef: MatDialogRef<BypassComponent>;
  dialogRelaunchRef: MatDialogRef<RelaunchComponent>;

  @Input() taskDetails: TaskDetailsObject;
  @Input() currentAssignTask: TaskAssignObject;

  userId: string;

  constructor(
    public dialog: MatDialog, private taskService: TaskService, private activatedRoute: ActivatedRoute,
    private notificationsService: NotificationsService,
    private router: Router,
    private keycloakService: KeycloakService,
    private utilsService: UtilsService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(!this.userId){
      const keycloakTokenParsed = this.keycloakService.getKeycloakInstance().tokenParsed;
      this.userId = keycloakTokenParsed['preferred_username'];
    }
    if (changes.currentAssignTask) {
      this.editable = this.currentAssignTask.equals(TaskAssignObject.TAKEN) && 
          this.utilsService.isAssignToUser(this.taskDetails, this.userId);
    }
  }

  ngOnInit() {

    const keycloakTokenParsed = this.keycloakService.getKeycloakInstance().tokenParsed;
    this.userId = keycloakTokenParsed['preferred_username'];
    
    this.diffCharacteristics = CharacteristicsObject.create();
    this.mustHideCharacteristics = false;

    this.activatedRoute.queryParams.subscribe(params => {
      this.taskId = params.id;
    });
  }

  public relaunch() {
    this.dialogRelaunchRef = this.dialog.open(RelaunchComponent, {
      width: '850px',
      data: this.diffCharacteristics
    });

    this.dialogRelaunchRef.afterClosed().subscribe((relaunchObject) => {
      if (relaunchObject.relaunch) {
        this.taskService.relaunchTask(this.userId, this.taskId,
          new TaskOperationObject(new MessageObject(relaunchObject.comments), relaunchObject.characteristics
          )).subscribe(
            (data) => {
              this.notificationsService.showNotification('La tarea se ha relanzado correctamente', NotificationLevel.SUCCESS);
              this.router.navigate(['/provision/tasks/search/']);
            },
            (error) => {
              this.notificationsService.showNotification('Ha habido un problema al relanzar la tarea', NotificationLevel.ERROR);
            }
          );
      }
    });
  }

  public byPass() {
    this.dialogBypassRef = this.dialog.open(BypassComponent, {
      width: '850px',
      data: this.diffCharacteristics
    });

    this.dialogBypassRef.afterClosed().subscribe((bypassObject) => {
      if (bypassObject.bypass) {
        this.taskService.skipTask(this.userId,
          this.taskId, new TaskOperationObject(new MessageObject(bypassObject.comments), bypassObject.characteristics)
        ).subscribe(
          (data) => {
            this.notificationsService.showNotification('Operación de bypass realizada correctamente', NotificationLevel.SUCCESS);
            this.router.navigate(['/provision/tasks/search/']);
          },
          (error) => {
            this.notificationsService.showNotification('Ha habido un problema al realizar la operación de bypass', NotificationLevel.ERROR);
          }
        );
      }
    });
  }

  onCharacteristicsChange($event: CharacteristicsObject) {
    this.diffCharacteristics = $event;
  }

}